import React, { useState } from "react";
import styled from "styled-components";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const AccordionRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-left: 1px solid #dadce0;
  border-right: 1px solid #dadce0;
  border-bottom: 1px solid #dadce0;
  background-color: #ffffff;

  &:first-child {
    border-radius: 8px 8px 0px 0px;
    border-top: 1px solid #dadce0;
  }

  &:last-child {
    border-radius: 0px 0px 8px 8px;
    border-bottom: 1px solid #dadce0;
  }

  &:only-child {
    border-radius: 8px;
  }
`;

const AccordionHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1em;
  box-sizing: border-box;
  box-shadow: ${(props) => (props.isExpanded ? "0px 10px 20px rgba(173, 174, 174, 0.25)" : "none")};
  z-index: 1;
  min-height: 70px;
`;
const AccordionHeaderSection = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const ExpandedRowWrapper = styled.div`
  display: flex;
  border-top: 1px solid #dadce0;
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
  min-height: 60px;
`;

const ShareAccordionExpandable = props => {
  const { headerContent, rowsContent } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpansion = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <AccordionRowWrapper>
      <AccordionHeaderRow isExpanded={isExpanded} onClick={handleExpansion}>
        <AccordionHeaderSection>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          {headerContent}
        </AccordionHeaderSection>
      </AccordionHeaderRow>
      {isExpanded && rowsContent?.length && rowsContent.map((rowContent, index) => <ExpandedRowWrapper key={index}>{rowContent}</ExpandedRowWrapper>)}
    </AccordionRowWrapper>
  );
};

export default ShareAccordionExpandable;
